export const contact_submit = "https://www.iamrachit.in/klsons/appapi/send_enquiry";
export const brands_url = "https://www.iamrachit.in/klsons/appapi/brands";
